<template>
  <div>
    <div v-if="!pod">
      File not found!
    </div>

    <div v-if="pod">
      <div class="d-flex " :class="$vuetify.display.xs ? 'flex-column' : ''">
        <div class="flex-grow-1 d-flex align-center">
          <h1>{{ $t('routes.pod.menuComment.commentsToolbar') }}</h1>
        </div>
        <div class="flex-grow-0 d-flex align-center">
          <v-tooltip location="bottom"
                     open-delay="200"
                     z-index="1200"
                     :aria-label="addCommentButtonLabel"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                color="primary"
                type="button"
                v-on:click="toggleForm"
                elevation=0
                data-cy="podMenu-comments-addComment"
                :aria-label="addCommentButtonLabel"
              >
                <v-icon>mdi-message-plus</v-icon>
              </v-btn>
            </template>

            <span v-if="isVideoPod">{{ $t('routes.pod.menuComment.submitCommentToVideo') }}</span>
            <span v-if="isAudioPod">{{ $t('routes.pod.menuComment.submitCommentToAudio') }}</span>
            <span v-if="isImagePod">{{ $t('routes.pod.menuComment.submitCommentToImage') }}</span>
          </v-tooltip>

          <v-menu v-model="showingInviteMenu" close-on-content-click>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" elevation=0 color="primary" class="ml-2">
                <v-icon>mdi-account-multiple-plus</v-icon>
                {{ $t('routes.pod.menuComment.inviteReviewersToolbar') }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="showInviteInternalReviewersDialog">
                <template v-slot:prepend>
                  <v-icon size="small">mdi-tooltip-account</v-icon>
                </template>

                <v-list-item-title>
                  {{ $t('routes.pod.menuComment.inviteInternalReviewers') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="showInviteExternalReviewersDialog">
                <template v-slot:prepend>
                  <v-icon size="small">mdi-share-circle</v-icon>
                </template>

                <v-list-item-title>
                  {{ $t('routes.pod.menuComment.inviteExternalReviewers') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <PodCommentForm
        v-if="showAddCommentForm"
        v-on:visibility="showAddCommentForm = $event"
        class="mt-4"
        data-cy="podMenu-comments-commentForm"
      />

      <PodCommentItem
        v-for="comment in comments"
        v-bind:key="comment.id"
        v-bind:comment="comment"
        v-bind:level="0"
        data-cy="podMenu-comments-commentItem"
      />

      <div
        v-if="$isFCPExtension() && comments.length > 0"
        class="text-center my-4">
        <v-btn color="primary" type="button" v-on:click="addCommentsToFCP" size="small">
          {{$t('routes.node.FCPAdd')}}
        </v-btn>
      </div>

    </div>
  </div>

  <InviteReviewerDialog
    v-model="showingInviteInternalReviewersDialog"
  />

  <AccesslinkCreateDialog
    v-model="showingInviteExternalReviewersDialog"
    v-if="pod && pod.node"
    :selectedPods="[pod]"
    :selectedNodes="[]"
    :rootNode="pod.node"
    :setAllowComments="true"
    :setNotifyViaEmail="true"
  />
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { usePodCommentStore } from '@/stores/PodCommentStore.js';
import PodCommentForm from "./PodCommentForm.vue"
import PodCommentItem from "./PodCommentItem.vue"
import InviteReviewerDialog from "./InviteReviewerDialog.vue"
import AccesslinkCreateDialog from '@/routes/nodes2/components/dialogs/AccesslinkCreateDialog.vue'
import Helper from '@/components/helper.js';

export default {
  name: "CommentsToolbar",
  components: {
    PodCommentForm,
    PodCommentItem,
    InviteReviewerDialog,
    AccesslinkCreateDialog,
  },
  data: function() {
    return {
      showingInviteMenu: false,
      showAddCommentForm: false,
      showingInviteInternalReviewersDialog: false,
      showingInviteExternalReviewersDialog: false,
      reviewNote: '',
    }
  },
  methods: {
    stub: function() {
      // do nothing
      this.showingInviteMenu = false;
    },
    showInviteInternalReviewersDialog: function() {
      this.showingInviteInternalReviewersDialog = true;
      this.showingInviteMenu = false;
    },
    showInviteExternalReviewersDialog: function() {
      this.showingInviteExternalReviewersDialog = true;
      this.showingInviteMenu = false;
    },
    toggleForm: function() {
      this.showAddCommentForm = !this.showAddCommentForm;
      if (this.showAddCommentForm) {
        this.closeOtherForms();
      }
    },
    closeOtherForms: function() {
      const value = 'add';
      const podCommentStore = usePodCommentStore();
      podCommentStore.setCloseFormsEvent(value);
    },
    addCommentsToFCP: function() {
      const mappedComments = this.comments.map((c) => this.mapVBCommentToFCPComment(c));
      const FCPObject = {
        action: "addComments",
        comments: mappedComments,
        fileName: this.pod.name,
        fileDuration: this.pod.asset.web[0].duration,
        frameRate: this.pod.asset.web[0].framerate
      };
      const finalObject = JSON.stringify(FCPObject);
      Helper.invokeFCPMessageHandler('comments', finalObject);
    },
    mapVBCommentToFCPComment: function (comment) {
      var name = "";
      if (comment.createdby && comment.createdby.firstname && comment.createdby.lastname) {
        name = comment.createdby.firstname + " " + comment.createdby.lastname;
      } else if (comment.email) {
        name = comment.email;
      }
      const note = comment.content;
      const date = comment.createdat;
      const start = comment.start;
      const end = comment.end;

      const object = {
        name,
        note,
        date,
        start,
        end,
      };
      return object;

    }

  },
  computed: {
    pod: function() {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
    comments: function() {
      const podCommentStore = usePodCommentStore();
      return podCommentStore.getComments(null);
    },
    isVideoPod: function () {
      const podStore = usePodStore();
      return podStore.isVideoPod;
    },
    isAudioPod: function () {
      const podStore = usePodStore();
      return podStore.isAudioPod;
    },
    isImagePod: function () {
      const podStore = usePodStore();
      return podStore.isImagePod;
    },
    totalVisibleForms: function() {
      const podCommentStore = usePodCommentStore();
      return podCommentStore.getVisibleForms;
    },
    showingAddComment: function() {
      return this.$canControlPodService() && !this.showAddCommentForm && this.totalVisibleForms === 0;
    },
    addCommentButtonLabel: function() {
      if (this.isVideoPod) {
        return this.$t('routes.pod.menuComment.submitCommentToVideo');
      }

      return this.isAudioPod
        ? this.$t('routes.pod.menuComment.submitCommentToAudio')
        : this.$t('routes.pod.menuComment.submitCommentToImage');
    }
  }
}
</script>

<style>
</style>
